export default [
  {
    path: '/admin/dealer-discounts',
    name: 'dealer-discount',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/dealer-discount')
  },
  {
    path: '/admin/dealer-discounts/create',
    name: 'dealer-discount-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/dealer-discount/create.vue')
  }
]
